import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface RatingItem {
  id: number;
  type: "movie" | "tv";
  rating: 1 | 2 | 3 | 4 | 5;
  ratedAt: number;
}

interface RatingsState {
  items: RatingItem[];
}

const initialState: RatingsState = {items: []};

const ratingsSlice = createSlice({
  name: "ratings",
  initialState,
  reducers: {
    rateItem(state, action: PayloadAction<{id: number; type: "movie" | "tv"; rating: 1 | 2 | 3 | 4 | 5}>) {
      const {id, type, rating} = action.payload;
      const existing = state.items.findIndex((i) => i.id === id && i.type === type);
      if (existing >= 0) {
        state.items[existing].rating = rating;
        state.items[existing].ratedAt = Date.now();
      } else {
        state.items.unshift({id, type, rating, ratedAt: Date.now()});
      }
    },
    removeRating(state, action: PayloadAction<{id: number; type: "movie" | "tv"}>) {
      state.items = state.items.filter(
        (i) => !(i.id === action.payload.id && i.type === action.payload.type)
      );
    },
    clearRatings(state) {
      state.items = [];
    },
  },
});

export const {rateItem, removeRating, clearRatings} = ratingsSlice.actions;
export default ratingsSlice.reducer;
